import { OverviewPageHeader, OverviewPageTable } from '~src/components/features/overview';
import { DefaultLayout } from '~src/components/layouts';

export const OverviewPage = () => {
  window.location.replace('https://ops.bodil.energy');
  return null;

  return (
    <DefaultLayout>
      <OverviewPageHeader />
      <OverviewPageTable />
    </DefaultLayout>
  );
};
